import type { RequestParams } from '@/shared/api';

export const TASK_KEYS = {
  all: ['task'] as const,
  list: (params?: RequestParams) => [...TASK_KEYS.all, 'list', params] as const,
  detail: (id: number) => [...TASK_KEYS.all, 'detail', id] as const,
};
